import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-tomato-50 py-4 mt-auto" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-center">
          <p className="text-sm text-tomato-600">
            Built by <a 
              href="https://vibe8.app" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="font-medium hover:underline"
              aria-label="Visit Vibe8.app website (opens in new tab)"
            >
              Vibe8.app
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
